import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsOverview = ({ totalCases, filteredCases }) => {
  const stats = [
    {
      icon: 'FileText',
      label: 'Total Cases',
      value: totalCases,
      color: 'text-primary'
    },
    {
      icon: 'Filter',
      label: 'Filtered Results',
      value: filteredCases,
      color: 'text-accent'
    },
    {
      icon: 'Award',
      label: 'Success Rate',
      value: '100%',
      color: 'text-success'
    },
    {
      icon: 'Clock',
      label: 'Avg. Timeline',
      value: '8-12 weeks',
      color: 'text-warning'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {stats?.map((stat, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-4 text-center hover:shadow-brand transition-shadow duration-300">
          <div className="flex items-center justify-center w-12 h-12 mx-auto mb-3 bg-muted rounded-lg">
            <Icon name={stat?.icon} size={20} className={stat?.color} />
          </div>
          <div className="text-lg font-semibold text-text-primary mb-1">
            {stat?.value}
          </div>
          <div className="text-xs text-text-secondary">
            {stat?.label}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsOverview;